import { render } from "./UpdateFarm.vue?vue&type=template&id=bd556d0e&ts=true"
import script from "./UpdateFarm.vue?vue&type=script&lang=ts"
export * from "./UpdateFarm.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__